import { render } from "./WarehouseDeliveryModal.vue?vue&type=template&id=4b4426d2&scoped=true"
import script from "./WarehouseDeliveryModal.vue?vue&type=script&lang=js"
export * from "./WarehouseDeliveryModal.vue?vue&type=script&lang=js"

import "./WarehouseDeliveryModal.vue?vue&type=style&index=0&id=4b4426d2&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4426d2"]])

export default __exports__